import type { ReactNode } from "react";

export function DiagnosticField({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div>
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="mt-1 break-words font-medium">{children || "Unknown"}</dd>
    </div>
  );
}

export function DiagnosticJson({
  title,
  value,
}: {
  title: string;
  value?: Record<string, unknown> | null;
}) {
  if (!value || Object.keys(value).length === 0) return null;
  return (
    <div>
      <div className="mb-2 font-medium">{title}</div>
      <pre className="max-h-52 overflow-auto rounded-md bg-muted p-3 text-xs">
        {JSON.stringify(value, null, 2)}
      </pre>
    </div>
  );
}
